module.exports = __webpack_public_path__ + "static/img/my.9aeb65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my.png
// module id = 4Ysc
// module chunks = 53